module.exports = __webpack_public_path__ + "img/gzh.7913d560.jpg";